import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'stx-scrollable-container',
  template: `<ng-content></ng-content>`,
  styles: [``]
})
export class ScrollableContainerComponent {}
